/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Permissions_Edit_DescriptionInputs */

const en_admin_permissions_edit_description = /** @type {(inputs: Admin_Permissions_Edit_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update permission details`)
};

/**
* | output |
* | --- |
* | "Update permission details" |
*
* @param {Admin_Permissions_Edit_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_permissions_edit_description = /** @type {((inputs?: Admin_Permissions_Edit_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Permissions_Edit_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_permissions_edit_description(inputs)
});
export { admin_permissions_edit_description as "admin.permissions.edit_description" }